module.exports = __webpack_public_path__ + "img/少云.1728a67c.png";